module.exports = __webpack_public_path__ + "img/bg.22397cda.png";